import { Alert } from '@creditsights/styleguide-web';
import { ReactElement } from 'react';

interface OnboardingAlertProps {
  onClose: () => void;
}

const OnboardingAlert = ({ onClose }: OnboardingAlertProps): ReactElement => (
  <Alert
    onClose={onClose}
    textContent="Your feed has been created based on your watchlist and interests. You can update them in the future under My Content."
  />
);

export default OnboardingAlert;
